import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import ClientStorage from '../../common/ClientStorage'
import { validateInput } from '../../Helpers'
import ClientAPI from '../../common/ClientAPI'
import loggerInstance from '../../common/Logger'
import LegalInfo from '../../components/LegalInfo'
import WalstoreBackButton from '../../components/WalstoreBackButton'
import { sendPageTypeDataToAnalytics } from '../../common/GoogleTagManager'
import VoidPDP from '../../functional-components/VoidPDP'
import getCategoriesForBreadcrumbs from './components/getCategoriesForBreadcrumbs'
import Head from '../../components/Head/Head'
import Loader from './components/Loader'
import ProductDetailContent from './components/ProductDetailContent'
import './components/index.css'
import LoadingLayout from '../../functional-components/LoadingLayout'
import LoadingProductDetail from '../../functional-components/LoadingProductDetail'
import constants from '../../common/constants'

class ProductDetail extends Component {
  constructor(props) {
    super(props)
    this.startLoad = performance.now()
    this.state = {
      productData: {},
      dataMenu: [],
      hasError: false,
      loading: true,
      showLoading: true,
    }
    this.configData = window.__ENV__
    this.clientAPI = new ClientAPI()
    this.clientStorage = new ClientStorage()
    this.isWalstore = this.configData.isWalstore === 'true'
  }

  componentDidMount = async () => {
    sendPageTypeDataToAnalytics('PDP')
    const { match, breadcrumbs, selectedSODStoreId } = this.props
    loggerInstance().then((logger) =>
      logger.info(
        {
          page: 'ProductDetail',
          sku: match.params.sku,
          'load-time': performance.now() - this.startLoad,
        },
        'Product Detail Page loaded'
      )
    )

    if (validateInput(/^[0-9A-Za-z]+$/g, match.params.sku)) {
      await this.handleNewProduct(match.params.sku, selectedSODStoreId)
      this.setState({ loading: false })
    } else {
      this.setState({ hasError: true })
    }

    if (!breadcrumbs) {
      this.clientStorage.getMenuCategories().then((response) => {
        const dataMenu = response
        this.setState({ dataMenu })
      })
    }
  }

  updateProduct = (product, showLoading = true) => {
    this.setState({ productData: product, showLoading })
  }

  async componentDidUpdate(nextProps) {
    const { match, selectedSODStoreId: nextSelectedSODStoreId } = nextProps
    const { match: propMatch, selectedSODStoreId } = this.props

    if (match.params.sku !== propMatch.params.sku || nextSelectedSODStoreId !== selectedSODStoreId) {
      if (this.state.showLoading) {
        this.setState({ loading: true })
        await this.handleNewProduct(propMatch.params.sku, nextSelectedSODStoreId)
        this.setState({ loading: false })
      }
      this.setState({ showLoading: true })
    }
  }

  handleNewProduct = async (search, selectedSODStoreId) => {
    const { selectedWalstoreStore, isSod } = this.props
    let storeId = ''

    if (this.isWalstore && selectedWalstoreStore.id) {
      storeId = selectedWalstoreStore.id
    } else if (isSod) {
      storeId = selectedSODStoreId
    }

    try {
      const product = await this.clientAPI.getProductBySKU(search, constants.APP_ID, storeId)

      this.setState({ productData: product })
    } catch (error) {
      this.setState({ hasError: true })
    }
    window.scrollTo(0, 0)
  }

  renderLoader = () => (
    <LoadingLayout>
      <LoadingProductDetail />
    </LoadingLayout>
  )

  render() {
    const { productData, hasError, dataMenu, loading } = this.state
    const { campaignConfig, location, breadcrumbs, isMobile, showLegalInfo, selectedSODStoreId, match } = this.props
    const { isWalstore } = this
    const sku = match.params.sku

    if (productData.error) {
      return <Redirect to="/error" />
    }

    let hit = {}
    let flowType = ''
    if (this.props && location && location.state) {
      const {
        state: { hit: hitLocation = {}, flowType: flowTypeFromProductCard },
      } = location
      hit = hitLocation
      flowType = flowTypeFromProductCard
      const { images = {} } = hit
      if (!images.availableImages) {
        hit.images = {
          availableImages: [],
        }
      }
    }
    const productInfo = productData || hit
    const showLoader = !productInfo.sku
    const info = {
      title: productInfo.displayName + '' + productInfo.brand,
    }

    if (hasError) return <VoidPDP sku={sku} />
    return (
      <Fragment>
        {loading ? (
          this.renderLoader()
        ) : (
          <div className="app-container">
            {productInfo.sku && <Head info={info} />}
            <div className="rct-app-content">
              <div className="rct-page">
                <div className="content-wrapper">
                  <div className="shop-wrapper">
                    <div className="rct-page">
                      <div className="rct-page-content">
                        <div className={isWalstore ? 'shop-wrapper product-detail__wrapper--walstore' : 'shop-wrapper'}>
                          {isWalstore && !isMobile && (
                            <div>
                              <WalstoreBackButton />
                            </div>
                          )}
                          <div className={isWalstore ? 'product-detail__content--walstore' : ''}>
                            {showLoader ? (
                              <Loader />
                            ) : (
                              <ProductDetailContent
                                productData={{ ...productInfo, tracking: hit?.tracking }}
                                isWalstore={isWalstore}
                                complementariesConfig={campaignConfig.pdpComplementaries}
                                categoriesBreadcrum={getCategoriesForBreadcrumbs(productData, breadcrumbs, dataMenu)}
                                flowType={flowType}
                                dtSearchEngine={location?.state?.dtSearchEngine}
                                searchState={location?.state?.searchState}
                                plpPosition={location?.state?.plpPosition}
                                selectedSODStoreId={selectedSODStoreId}
                                updateProduct={this.updateProduct}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showLegalInfo && <LegalInfo isMobile={isMobile} isPDP />}
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  campaignConfig: state.campaignConfigReducer,
  selectedWalstoreStore: state.selectedWalstoreStore,
})

ProductDetail.defaultProps = {
  location: { state: { hit: {} } },
  match: {},
  breadcrumbs: undefined,
  selectedWalstoreStore: {},
  selectedSODStoreId: undefined,
  isSod: false,
  isMobile: false,
  showLegalInfo: true,
}

ProductDetail.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  campaignConfig: PropTypes.object.isRequired,
  breadcrumbs: PropTypes.object,
  selectedWalstoreStore: PropTypes.object,
  selectedSODStoreId: PropTypes.number,
  isSod: PropTypes.bool,
  isMobile: PropTypes.bool,
  showLegalInfo: PropTypes.bool,
}

export default connect(mapStateToProps)(ProductDetail)
